import TournamentCard from './TournamentCard';
import './TournamentList.css';

export default function TournamentList({ tournaments, variant = 'circuit', emptyMessage }) {
  const defaultEmpty = variant === 'non-circuit'
    ? 'Aucun tournoi mis en avant pour le moment.'
    : 'Aucun tournoi Champions Collective pour le moment.';

  if (!tournaments || tournaments.length === 0) {
    return (
      <div className="tournament-list__empty chiron-goround-tc-body">
        <p>{emptyMessage || defaultEmpty}</p>
      </div>
    );
  }

  return (
    <div className="tournament-list">
      {tournaments.map((tournament) => (
        <TournamentCard key={tournament.id} tournament={tournament} variant={variant} />
      ))}
    </div>
  );
}
